const PermissionLevels = Object.freeze({
  View: "view",
  Edit: "edit",
} as const);

export type PermissionLevels =
  (typeof PermissionLevels)[keyof typeof PermissionLevels];

export const PermissionLabels = Object.freeze({
  [PermissionLevels.View]: "View",
  [PermissionLevels.Edit]: "Edit",
});

export default PermissionLevels;
